import { render, staticRenderFns } from "./TraceyChatWindow.vue?vue&type=template&id=68521735&scoped=true"
import script from "./TraceyChatWindow.vue?vue&type=script&lang=js"
export * from "./TraceyChatWindow.vue?vue&type=script&lang=js"
import style0 from "./TraceyChatWindow.vue?vue&type=style&index=0&id=68521735&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68521735",
  null
  
)

export default component.exports